// extracted by mini-css-extract-plugin
module.exports = {"message":"the-error-page_message_1iW_l"};